import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { cContainer } from "./cContainer";


export class cScrollContainer extends cContainer {

  private _bg: Phaser.GameObjects.Graphics
  private _mask: Phaser.GameObjects.Graphics
  private _padding: number = 0;
  private minX: number = 0
  private minY: number = 0;
  private maxX: number = 0
  private maxY: number = 0;

  public direction: string 

  constructor(sc:cScene, data: ScreenItem){
    super(sc,data);
    this._bg = this.scene.add.graphics()
    this.direction = this.modules.data.data.initProps.direction
    if (!this.direction) this.direction = 'vertical'
    this.add(this._bg)
    

    this.maxX = this.modules.layout.origin_x
    this.maxY = this.modules.layout.origin_y

    setTimeout(()=>{
      this.drawMask()

      this.setInteractive({
        hitArea:this._mask,
        useHandCursor:true, 
        draggable: true, 
        hitAreaCallback:(hit:any,x:any,y:any,ref:any)=>{ 
          return true
          // if (x > xx && y > $this._mask.y && x < $this.x + wi && y < $this.y + hi){            
          //   return true
          // }else{
          //   return false
          // }
        } 
      })
      this.scene.input.setDraggable( this )
      this.scene.input.on('dragstart',this.dragStart,this)
      this.scene.input.on('drag',this.dragging,this)
      this.scene.input.on('dragend',this.dragEnd,this)
      console.log('DRAG')
    },1)


    this._mask = this.scene.add.graphics()    
    this.add(this._bg)
    //this.add(this._mask)
  }

  dragStart(){
    console.log('START')
  }

  dragEnd(){
    console.log('END')

  }

  dragging (pointer:any, gameObject:any, dragX:number, dragY:number){
    if (gameObject === this){      
      if (this.direction === 'vertical'){

        console.log(dragY, this.minY)


        if (dragY > this.maxY) dragY = this.maxY
        if (dragY < this.minY) dragY = this.minY
        gameObject.y = dragY
      }else{
        if (dragX > this.maxX) dragX = this.maxX
        if (dragX < this.minX) dragX = this.minX
        gameObject.x = dragX

      }

    }
  }


  drawMask(){
    var wi = this.modules.data.data.initProps.maskWidth || 0
    var hi = this.modules.data.data.initProps.maskHeight || 0

    this._mask.clear()
    this._mask.fillStyle(0xFF0000, 0);
    this._mask.fillRect(0, 0, wi, hi);    
    this._mask.x = this.modules.layout.origin_x
    this._mask.y = this.modules.layout.origin_y


    if (wi !== 0 && hi !== 0){
      this.mask = this.createGeometryMask(this._mask)
    }

    //this.setSize(wi, hi);
    console.log('masksize',wi,hi)

  }


  redrawShape(){
    var wi = this.modules.data.data.initProps.maskWidth || 0
    var hi = this.modules.data.data.initProps.maskHeight || 0

    var maxSi = this.getAll().reduce( (payload:any,gm:any)=>{
      if (gm instanceof Phaser.GameObjects.Graphics){
        return payload
      }
      payload.sx = Math.max(payload.sx, gm.x + gm.displayWidth  )
      payload.sy = Math.max(payload.sy, gm.y + gm.displayHeight  )      
      return payload
    },{sx:0,sy:0})

    this._bg.clear()
    this._bg.fillStyle(0xFF0000, 1.0);
    this._bg.fillRect(0, 0, maxSi.sx, maxSi.sy);    

    this.minX = wi - maxSi.sx
    this.minY = hi - maxSi.sy



  }

  public refresh(){

  }

  add(child: Phaser.GameObjects.GameObject | Phaser.GameObjects.GameObject[]):this {
    var r = super.add(child)
    this.redrawShape()

    return r
  }


}